var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSertificateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C3.89543 3 3 3.89543 3 5V15C3 16.1046 3.89543 17 5 17H14V14C14.0001 11.2386 16.2386 9 19 9C19.7111 9 20.3875 9.14845 21 9.41604V5C21 3.89543 20.1046 3 19 3H5ZM7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H12C12.5523 8 13 7.55228 13 7C13 6.44772 12.5523 6 12 6H7ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H9C9.55228 12 10 11.5523 10 11C10 10.4477 9.55228 10 9 10H7Z",
    fill: "#985EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.7639C20.4692 11.2889 19.7684 11 19 11C17.3432 11 16.0001 12.3431 16 13.9999C16 13.9998 16 13.9999 16 13.9999C16 14.7682 16.2887 15.4692 16.7637 16C17.3131 16.6139 18.1114 17.0002 19 17.0002C19.8886 17.0002 20.6869 16.6139 21.2363 16C21.7113 15.4692 22 14.7684 22 14C22 13.1115 21.6137 12.3132 21 11.7639Z",
    fill: "#985EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18.0005V22.0657C16 22.4651 16.4451 22.7033 16.7774 22.4818L17.8906 21.7396C18.5624 21.2917 19.4376 21.2917 20.1094 21.7396L21.2227 22.4818C21.5549 22.7033 22 22.4651 22 22.0657V18.0005C21.1643 18.6282 20.1256 19.0002 19 19.0002C17.8744 19.0002 16.8357 18.6282 16 18.0005Z",
    fill: "#985EFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSertificateIcon);
export default __webpack_public_path__ + "static/media/sertificate_icon.25a928f8fb3160acf7daacfc99b28fbf.svg";
export { ForwardRef as ReactComponent };